import * as React from 'react';

export const loader = () => {
  return <i className={'fa fa-spin fa-spinner'} />;
};
